import { Check, MapPin, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICE_TYPES, formatDate, mapsSearch, telHref, whatsappHref } from "@/lib/services";

const WhatsAppButton = ({ s }) => {
  const { company, messaging } = useServices();
  const href = whatsappHref(s, company, messaging?.visit_template);
  if (!href) {
    return (
      <Button size="sm" variant="outline" disabled title="Cadastre o telefone na ficha do cliente" className="rounded-full border-slate-700 bg-transparent" data-testid={`route-whatsapp-button-${s.id}`}>
        <MessageCircle className="h-3.5 w-3.5 sm:mr-1" /><span className="hidden sm:inline">WhatsApp</span>
      </Button>
    );
  }
  return (
    <Button asChild size="sm" className="rounded-full bg-[#25D366] text-slate-950 hover:bg-[#1fb857]" data-testid={`route-whatsapp-button-${s.id}`}>
      <a href={href} target="_blank" rel="noreferrer" title="Enviar confirmação pelo WhatsApp">
        <MessageCircle className="h-3.5 w-3.5 sm:mr-1" /><span className="hidden sm:inline">WhatsApp</span>
      </a>
    </Button>
  );
};
import { useServices } from "@/context/ServicesContext";

export const RouteStop = ({ s, n, showDate = false }) => {
  const { openComplete, openClient } = useServices();
  const t = SERVICE_TYPES[s.service_type];
  return (
    <li className="flex gap-3 rounded-xl border border-slate-700/60 bg-slate-800/60 p-4" style={{ borderLeft: `3px solid ${t.hex}` }} data-testid={`route-stop-${s.id}`}>
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-mono text-xs font-bold text-slate-900" style={{ background: t.hex }}>{n}</span>
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center gap-2">
          <button onClick={() => openClient(s.client_name)} className="truncate text-left font-semibold hover:underline" data-testid={`route-client-${s.id}`}>{s.client_name}</button>
          <span className="text-xs text-slate-400">{t.label}</span>
          {showDate && <span className="rounded-full border border-rose-500/40 bg-rose-500/15 px-2 py-0.5 text-[11px] font-semibold text-rose-300">desde {formatDate(s.execution_date)}</span>}
        </div>
        <div className="flex items-center gap-1.5 text-sm" data-testid={`route-phone-${s.id}`}>
          <Phone className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          {s.phone ? <a href={telHref(s.phone)} className="hover:underline">{s.phone}</a> : <span className="text-slate-500">Sem telefone</span>}
        </div>
        <div className="flex items-start gap-1.5 text-sm" data-testid={`route-address-${s.id}`}>
          <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-400" />
          {s.address ? <a href={mapsSearch(s.address)} target="_blank" rel="noreferrer" className="hover:underline">{s.address}</a> : <span className="text-slate-500">Sem endereço — adicione na ficha do cliente</span>}
        </div>
      </div>
      <div className="flex shrink-0 flex-col items-stretch gap-2 self-start">
        <WhatsAppButton s={s} />
        <Button size="sm" onClick={() => openComplete(s)} className="rounded-full" data-testid={`route-done-button-${s.id}`}>
          <Check className="h-3.5 w-3.5 sm:mr-1" /><span className="hidden sm:inline">Realizar</span>
        </Button>
      </div>
    </li>
  );
};
